export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_18.825be25b.jpg";